import {
  Directive,
  HostListener,
  Input,
  HostBinding,
  Output,
  EventEmitter
} from '@angular/core';

@Directive({
  selector: '[appResizerVertical]'
})
export class ResizerVerticalDirective {
  height: number;
  oldY = 0;
  grabber = false;
  @Input() minHeight;
  @Input() idOfHeightElementToGrab: string;
  @Output() public onResizeEmit = new EventEmitter<void>();
  @HostBinding('style.height') divHeight;
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.grabber) {
      return;
    }
    this.onResizeEmit.emit();
    this.resizer(event.clientY - this.oldY); // will be 1 or -1 if increase or decrease size
    this.oldY = event.clientY;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(_: MouseEvent) {
    this.grabber = false; // stop grabbing
  }

  resizer(offsetY: number) {
    if (this.height + offsetY > this.minHeight) {
      // new height must be bigger then the min height
      this.height += offsetY;
      this.divHeight = this.height + 'px'; // set the height of the div
    }
  }

  @HostListener('mousedown', ['$event']) onResize(event: MouseEvent) {
    this.height = event.target['offsetHeight'];
    if (
      // we want to make sure what is being clicked on and dragged is at the bottom of the div, so within 10px of the border
      Math.abs(event.offsetY - this.height) <= 10 &&
      [...event.target['classList']].includes('resize-able') // whats clicked on must be the content
    ) {
      this.grabber = true; //allows div to be resize
      this.oldY = event.clientY;
      event.preventDefault(); // stops things like text being highlighted
    }
  }
}
